import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import DataTable from '../Table/DataTable';
import SearchBox from '../SearchBox/SearchBox';

import { showAlert } from '../../store/ducks/alert';
import { getRecipients } from '../../services/payment';
import { CircularProgress } from '@material-ui/core';

/** Helpers */
import getRecipentSource from '../../helpers/getRecipentSource';

const Recipients = ({ channelId }) => {
  const dispatch = useDispatch();
  const params = useParams();

  const [recipients, setRecipients] = useState([]);
  const [actualPage, setActualPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [orderDirections, setOrderDirections] = useState({ item: 'createdAt', direction: 'ASC' });

  useEffect(() => {
    let page;
    let parsedParams = {};
    if (channelId) {
      parsedParams = { searchItem: 'channelId', search: channelId };
    } else {
      page = params.page || actualPage;
      if (params.search && params.searchItem) {
        parsedParams = { ...parsedParams, search: params.search, searchItem: params.searchItem };
        if (params.searchItem == 'status') {
          parsedParams = { ...parsedParams, order: 'createdAt', direction: 'ASC' };
          setOrderDirections({ item: 'createdAt', direction: 'ASC' });
        }
        setSearch(parsedParams);
        setIsSearching(true);
      }
    }
    handleGetRecipients(page, parsedParams);
  }, []);

  const handleSubmitSearch = searchBox => {
    setSearch(searchBox);
    setIsSearching(true);
    handleGetRecipients(0, searchBox);
  };

  const handleChangePage = async page => {
    setActualPage(page);
    handleGetRecipients(page, search);
  };

  const headers = ['channelId', 'token', 'source', 'status', 'enabled', 'ourTax'];

  const handleGetRecipients = async (page, searchObject) => {
    try {
      if (!page) page = actualPage;
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 10 };
      if (searchObject) params = { ...searchObject, ...params };

      const { data: recipientsData } = await getRecipients(page, params);

      setRecipients(
        recipientsData.rows.map(item => ({
          channelId: item.channelId,
          source: getRecipentSource(item.paymentOriginId),
          token: item.paymentOriginToken,
          status: item.status,
          ourTax: `${item.ourTax}%`,
        }))
      );
      setTotalItems(recipientsData.count);
      setTotalPages(recipientsData.pages);
      setActualPage(recipientsData.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Recipients ({totalItems})</h1>
        {!channelId && <SearchBox selectItems={['status', 'channelId']} onSubmitSearch={handleSubmitSearch} isSearching={isSearching} />}
      </div>
      <DataTable
        useUid={true}
        head={headers}
        body={recipients}
        action={false}
        bodyColumn={headers}
        totalPages={totalPages}
        currentPage={actualPage}
        setPageChange={handleChangePage}
      />
    </>
  );
};

export default Recipients;
